export const TIPOS_OPERACION = Object.freeze({
	NACIONAL: "nacional",
	PUERTOS: "puertos",
	PRIMERA_MILLA: "primera_milla",
});

// Portal que atiende a cada tipo de operación. Primera milla no tiene dominio propio:
// entra por el portal nacional.
export const PORTAL_POR_TIPO = Object.freeze({
	[TIPOS_OPERACION.NACIONAL]: TIPOS_OPERACION.NACIONAL,
	[TIPOS_OPERACION.PUERTOS]: TIPOS_OPERACION.PUERTOS,
	[TIPOS_OPERACION.PRIMERA_MILLA]: TIPOS_OPERACION.NACIONAL,
});

export const PORTAL_URLS = Object.freeze({
	[TIPOS_OPERACION.NACIONAL]: "https://t.vink.com.mx",
	[TIPOS_OPERACION.PUERTOS]: "https://p.vink.com.mx",
	[TIPOS_OPERACION.PRIMERA_MILLA]: "https://t.vink.com.mx",
});

const TIPO_POR_HOST = Object.freeze({
	"t.vink.com.mx": TIPOS_OPERACION.NACIONAL,
	"p.vink.com.mx": TIPOS_OPERACION.PUERTOS,
});

export const PORTAL_CONFIGS = Object.freeze({
	[TIPOS_OPERACION.NACIONAL]: {
		tipoOperacion: TIPOS_OPERACION.NACIONAL,
		label: "viajes nacionales",
		homePath: "/",
		features: {
			viajesNacionales: true,
			viajesPortuarios: false,
			solicitudesNacionales: true,
			solicitudesPortuarias: false,
			registroEstadosOperacion: true,
			registroDefinicionOperacion: true,
			registroDatosPortuarios: false,
			equipos: false,
			tarifasPuertos: false,
			configuracionPuertos: false,
			documentoCaat: false,
			unidadTipoContenedor: false,
			unidadGafete: false,
			notificacionesPuertos: false,
		},
	},
	[TIPOS_OPERACION.PUERTOS]: {
		tipoOperacion: TIPOS_OPERACION.PUERTOS,
		label: "puertos",
		homePath: "/portuarios",
		features: {
			viajesNacionales: false,
			viajesPortuarios: true,
			solicitudesNacionales: false,
			solicitudesPortuarias: true,
			registroEstadosOperacion: false,
			registroDefinicionOperacion: false,
			registroDatosPortuarios: true,
			equipos: true,
			tarifasPuertos: true,
			configuracionPuertos: true,
			documentoCaat: true,
			unidadTipoContenedor: true,
			unidadGafete: true,
			notificacionesPuertos: true,
		},
	},
});

export function resolveTipoOperacion({hostname, configuredType} = {}){
	const host = String(hostname || "").toLowerCase();
	if(TIPO_POR_HOST[host]) return TIPO_POR_HOST[host];
	if(PORTAL_CONFIGS[configuredType]) return configuredType;
	return TIPOS_OPERACION.NACIONAL;
}

export function getTiposOperacion(transportista){
	const tipos = Array.isArray(transportista?.tipos_operacion)
		? transportista.tipos_operacion.filter(tipo => PORTAL_POR_TIPO[tipo])
		: [];
	return tipos.length ? [...new Set(tipos)] : [TIPOS_OPERACION.NACIONAL];
}

export function puedeAccederPortal(transportista, tipoOperacion){
	const portal = PORTAL_POR_TIPO[tipoOperacion];
	if(!portal) return false;
	return getTiposOperacion(transportista).some(tipo => PORTAL_POR_TIPO[tipo] === portal);
}

export function esPrimeraMilla(transportista){
	return getTiposOperacion(transportista).includes(TIPOS_OPERACION.PRIMERA_MILLA);
}

const currentTipoOperacion = resolveTipoOperacion({
	hostname: typeof window === "undefined" ? "" : window.location.hostname,
	configuredType: process.env.REACT_APP_PORTAL,
});

export const portalConfig = PORTAL_CONFIGS[currentTipoOperacion];
